// extracted by mini-css-extract-plugin
module.exports = {"comp":"O2_comp__m8zSv"};